<div mat-dialog-title>
  <span>{{ "DIALOG_GENERATE_PLANNED_LINE" | translate}}</span>
  <button mat-icon-button
    mat-dialog-close>
    <fa-icon icon="times"></fa-icon>
  </button>
</div>
<form [formGroup]="eventForm"
  (ngSubmit)="generateEvent()">

  <div class="custom-scrollbar"
    mat-dialog-content>
    <div class="form-container">
      <div class="operation-selection">
        <label id="operations">
          {{'OPERATIONS_RADIO_BUTTON_LABEL' | translate}}
        </label>
        <mat-radio-group aria-labelledby="operations"
          formControlName="operationType">
          @for (operation of OperationType | keyvalue; track operation) {
            <mat-radio-button class="form-radio-button"
              [value]="operation.value">
              {{ operation.value | uppercase | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'PARENT_FAMILY' | translate }}</mat-label>
        <mat-select formControlName="parentFamily">
          <mat-option>
            <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
              [formControl]="searchForm.controls.parentFamily"
              [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option>
            <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
          </mat-option>
          @for (parentFamily of parentFamilies$
            | async
            | listFilter:'name':searchForm.value.parentFamily:true:true
            | sort:false:'name'
            | slice:0:200; track parentFamily) {
            <mat-option
              [value]="parentFamily.id">
              {{ parentFamily.name }}
            </mat-option>
          }
        </mat-select>
        <mat-hint>
          @if ((loadings.parentFamilies$ | async) === true) {
            <mat-progress-spinner mode="indeterminate"
              diameter="12"
            strokeWidth="2"></mat-progress-spinner>
            {{ "LOADING_DATA" | translate }}
          } @else {
            @if ((parentFamilies$ | async | listFilter:'name':searchForm.value.parentFamily:true:true)?.length > 200) {
              {{ "LIST_LIMITED_QTY" | translate:{number:'200'} }}
            }
          }
        </mat-hint>
        @if ((loadings.parentFamilies$ | async) === false && eventForm.controls.parentFamily.errors?.required) {
          <mat-error
            >
            <fa-icon icon="circle-exclamation"></fa-icon>
            {{ "REQUIRED_SELECTION" | translate }}
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'ASSET_FAMILY' | translate }}</mat-label>
        <mat-select formControlName="assetFamily">
          <mat-option>
            <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
              [formControl]="searchForm.controls.assetFamily"
              [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option>
            <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
          </mat-option>
          @for (family of families$
            | async
            | listFilter:'name':searchForm.value.assetFamily:true:true
            | sort:false:'name'
            | slice:0:200; track trackById(family)) {
            <mat-option
              [value]="family.id">
              {{ family.name }}
            </mat-option>
          }
        </mat-select>
        <mat-hint>
          @if ((loadings.families$ | async) === true) {
            <mat-progress-spinner mode="indeterminate"
              diameter="12"
            strokeWidth="2"></mat-progress-spinner>
            {{ "LOADING_DATA" | translate }}
          } @else {
            @if ((families$ | async | listFilter:'name':searchForm.value.assetFamily:true:true)?.length > 200) {
              {{ "LIST_LIMITED_QTY" | translate:{number:'200'} }}
            }
          }
        </mat-hint>
        @if ((loadings.families$ | async) === false && eventForm.controls.assetFamily.errors?.required) {
          <mat-error
            >
            <fa-icon icon="circle-exclamation"></fa-icon>
            {{ "REQUIRED_SELECTION" | translate }}
          </mat-error>
        }
      </mat-form-field>  

      @if (eventForm.value.operationType === OperationType.arrival ||
          eventForm.value.operationType === OperationType.departure) {
          <mat-form-field appearance="outline">
              <mat-label>{{ 'ASSET' | translate }}</mat-label>

              <mat-select formControlName="asset">
                  <mat-option>
                      <ngx-mat-select-search
                          [placeholderLabel]="'SEARCH' | translate"
                          [formControl]="searchForm.controls.asset"
                          [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
                      </ngx-mat-select-search>
                  </mat-option>

                  <mat-option>
                      <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
                  </mat-option>

                  @for (asset of (assets$
                      | async
                      | listFilter:'name':searchForm.value.asset:true:true
                      | sort:false:'name'
                      | slice:0:200); track asset.id) {
                      <mat-option [value]="asset.id">
                          {{ asset.name }}
                      </mat-option>
                  }
              </mat-select>

              <mat-hint>
                  @if ((loadings.assets$ | async) === true) {
                      <mat-progress-spinner
                          mode="indeterminate"
                          diameter="12"
                          strokeWidth="2">
                      </mat-progress-spinner>
                      {{ "LOADING_DATA" | translate }}
                  } @else {
                      @if ((assets$ | async | listFilter:'name':searchForm.value.asset:true:true)?.length > 200) {
                          {{ "LIST_LIMITED_QTY" | translate:{number:'200'} }}
                      }
                  }
              </mat-hint>

              @if ((loadings.assets$ | async) === false &&
                  eventForm.controls.asset.errors?.required) {
                  <mat-error>
                      <fa-icon icon="circle-exclamation"></fa-icon>
                      {{ "REQUIRED_SELECTION" | translate }}
                  </mat-error>
              }
          </mat-form-field>
      }


      <mat-form-field appearance="outline">
        <mat-label>{{ 'PLANNED_DATE' | translate }}</mat-label>
        <input matInput
          [mtxDatetimepicker]="plannedDatepicker"
          formControlName="plannedDate">
          <mtx-datetimepicker-toggle [for]="plannedDatepicker"
          matSuffix></mtx-datetimepicker-toggle>
          <mtx-datetimepicker #plannedDatepicker
          multiYearSelector></mtx-datetimepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'PLANNED_LOCATION' | translate }}</mat-label>
          <mat-select formControlName="plannedLocation">
            <mat-option>
              <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
                [formControl]="searchForm.controls.plannedLocation"
                [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option>
              <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
            </mat-option>
            @for (zone of zones$
              | async
              | listFilter:'name':searchForm.value.plannedLocation:true:true
              | sort:false:'name'
              | slice:0:200; track trackById(zone)) {
              <mat-option
                [value]="zone.id">
                {{ zone.name }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>
            @if ((loadings.zones$ | async) === true) {
              <mat-progress-spinner mode="indeterminate"
                diameter="12"
              strokeWidth="2"></mat-progress-spinner>
              {{ "LOADING_DATA" | translate }}
            } @else {
              @if ((zones$ | async)?.length > 200) {
                {{ "LIST_LIMITED_QTY" | translate:{number:'200'} }}
              }
            }
          </mat-hint>
          @if ((loadings.zones$ | async) === false && eventForm.controls.assetFamily.errors?.required) {
            <mat-error
              >
              <fa-icon icon="circle-exclamation"></fa-icon>
              {{ "REQUIRED_SELECTION" | translate }}
            </mat-error>
          }
        </mat-form-field>

        @if (eventForm.value.operationType === OperationType.load || eventForm.value.operationType === OperationType.unload) {
          <mat-form-field appearance="outline">
            <mat-label>{{ "COMPATIBLE_SECTION" | translate }}</mat-label>
            <mat-select formControlName="section">
              <mat-option>
                <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
                  [formControl]="searchForm.controls.section"
                  [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option>
                <i>-- {{ 'CLEAR_SELECTION' | translate }} --</i>
              </mat-option>
              @for (section of section$
                | async
                | listFilter:null:searchForm.value.section:true:true
                | sort
                | slice:0:200; track trackById(section)) {
                <mat-option
                  [value]="section">
                  {{ section }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>
              @if ((loadings.families$ | async) === true) {
                <mat-progress-spinner mode="indeterminate"
                  diameter="12"
                strokeWidth="2"></mat-progress-spinner>
                {{ "LOADING_DATA" | translate }}
              } @else {
                @if ((section$ | async| listFilter:null:searchForm.value.section:true:true)?.length > 200) {
                  {{ "LIST_LIMITED_QTY" | translate:{number:'200'} }}
                }
              }
            </mat-hint>
            @if ((loadings.families$ | async) === false && eventForm.controls.assetFamily.errors?.required) {
              <mat-error
                >
                <fa-icon icon="circle-exclamation"></fa-icon>
                {{ "REQUIRED_SELECTION" | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{"MSN" | translate}}</mat-label>
            <input matInput
              formControlName="msn" />
            </mat-form-field>
          }

        </div>
      </div>
      <div mat-dialog-actions>
        <button mat-stroked-button
          mat-dialog-close
          color="primary"
          type="button">
          {{ "CANCEL" | translate }}
        </button>
        <button type="submit"
          mat-flat-button
          color="primary"
          [disabled]="!eventForm.valid || loadings.submit">
          {{ "GENERATE" | translate }}
          @if (loadings.submit) {
            <mat-progress-spinner
              mode="indeterminate"
              diameter="16"
              strokeWidth="2">
            </mat-progress-spinner>
          }
        </button>
      </div>
    </form>
